import { Footer as FooterPrivacyArea } from '@doda/io-react/pc';
import { FC } from 'react';
import { LinkList, FooterExternalSites } from './components/ExternalSiteLinks';
import { Navigation } from './components/Navigation';
import styles from './index.module.scss';

/**
 * FooterProps
 */
interface Props {
  externalSiteLinkList?: LinkList;
  hasNavigation?: boolean;
  hasFooterExternalSites?: boolean;
}

export const Footer: FC<Props> = ({
  externalSiteLinkList,
  hasNavigation = true,
  hasFooterExternalSites = true,
}) => {
  return (
    <section className={styles.footer_wrapper}>
      {hasNavigation && <Navigation />}
      {hasFooterExternalSites && (
        <FooterExternalSites externalSiteLinkList={externalSiteLinkList} />
      )}
      <FooterPrivacyArea />
    </section>
  );
};
